import { ChannelsConfig } from "../../ChannelsConfig";
import { STR_ERRORS } from "../../Strings";
export function getChannelData(connName, message) {
    const connectionChannels = ChannelsConfig[connName];
    if (typeof connectionChannels === "undefined") {
        throw new Error(STR_ERRORS.NoChannelMappingForConnection);
    }
    const channel = connectionChannels[message.name];
    if (typeof channel === "undefined") {
        throw new Error(STR_ERRORS.NoChannel);
    }
    else if (typeof channel.path === "function") {
        return Object.assign(Object.assign({}, channel.path(message.params)), { method: getMethod(channel.method) });
    }
    return {
        channel: channel.path,
        method: getMethod(channel.method),
        params: message.params
    };
}
function getMethod(method = "GET") {
    return method;
}
//# sourceMappingURL=GetChannelData.js.map